<template>
  <v-card class="invoicePreviewWrapCard max-shadow">
    <v-card-title
      v-if="type === 'invoice'"
      class="title"
    >
      {{ invoice.invoiceNumber }} Preview
    </v-card-title>
    <v-card-title
      v-else
      class="title"
    >
      {{ invoice.name }} Preview
    </v-card-title>
    <div class="invoicePreviewWrap blue-grey lighten-4 pa-2">
      <iframe
        id="invoicePreview"
        ref="invoicePreview"
        name="invoicePreview"
      />
    </div>
    <v-card-actions>
      <v-spacer />
      <v-btn
        color="primary"
        flat
        @click="$emit('close')"
      >
        close
      </v-btn>
      <template v-if="type === 'invoice'">
        <v-btn
          color="primary"
          flat
          @click="printInvoice"
        >
          print
        </v-btn>
      </template>
    </v-card-actions>
  </v-card>
</template>
<script>
import axios from 'axios';
import * as moment from 'moment';
import handlebars from 'handlebars/dist/cjs/handlebars';
import '@/utils/handlebar-helpers';
import { firestore } from '@/firebase';

export default {
  name: 'InvoicePreview',
  props: {
    invoice: {
      type: Object,
      default: () => {},
      required: true
    },
    type: {
      type: String,
      default: '',
      required: true
    }
  },
  data() {
    return {
      renderedInvoiceHTML: '',
      dateFormat: 'DD MMM YYYY',
      address: {},
      GSTIN: ''
    };
  },
  computed: {
    formattedInvoice() {
      const formatted = Object.assign({}, this.invoice);
      formatted.invoiceDate = moment(this.invoice.invoiceDate.toDate()).format(
        this.dateFormat
      );
      formatted.dueDate = moment(this.invoice.dueDate.toDate()).format(
        this.dateFormat
      );
      formatted.maxAdminAddress = this.address;
      formatted.maxAdminGSTIN = this.GSTIN;
      return formatted;
    },
    formattedRecurringInvoice() {
      const formatted = Object.assign({}, this.invoice);
      formatted.startDate = moment(this.invoice.startDate.toDate()).format(
        this.dateFormat
      );
      formatted.maxAdminAddress = this.address;
      formatted.maxAdminGSTIN = this.GSTIN;
      return formatted;
    }
  },
  mounted() {
    firestore
      .doc('settings/maxTowers')
      .get()
      .then(settingsSnapshot => {
        const settings = settingsSnapshot.get('billingSettings');
        this.address = settings.address;
        this.GSTIN = settings.GSTIN;
        this.renderInvoice();
      });
  },
  methods: {
    renderInvoice() {
      const url =
        this.type === 'invoice'
          ? '/templates/invoice.hbs'
          : '/templates/recurringInvoice.hbs';
      axios.get(url).then(response => {
        const data = {
          invoiceNumber: this.invoice.invoiceNumber,
          invoice:
            this.type === 'invoice'
              ? this.formattedInvoice
              : this.formattedRecurringInvoice
        };

        const template = handlebars.compile(response.data);

        const html = template(data);
        this.renderedInvoiceHTML = html;
        const preview = document.getElementById('invoicePreview');
        preview.srcdoc = html;
      });
    },

    navigateBack() {
      this.$router.back();
    },

    printInvoice() {
      this.$refs.invoicePreview.contentWindow.print();
    }
  }
};
</script>
<style>
.invoicePreviewWrap {
  height: calc(100vh - var(--toolbar-height));
  overflow-y: scroll;
  text-align: center;
}
.invoicePreviewWrapCard {
  height: calc(100vh - var(--toolbar-height));
  overflow: hidden;
}
#invoicePreview {
  margin: auto;
  width: 210mm;
  height: 297mm;
  zoom: 0.9;
  border-width: 0;
}
</style>

